import { Helmet } from 'react-helmet-async';

import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

// @mui
import {
  Box,
  Button,
  CircularProgress,
  Container,
  Grid,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import PropTypes from 'prop-types';
import {
  DeleteCandidateAttachment,
  DownloadTreeAttachment,
  GetCandidateAttachmentsList,
  PostCandidateAttachment,
} from 'src/components/services/httpServices';

import { Download, Trash } from 'react-feather';
import ModalLayout from 'src/theme/Modal';
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
export default function CandidateAttachmentsList(props) {
  let { id } = useParams();
  const navigate = useNavigate();
  const [attachments, setAttachments] = useState({});
  const [vertical, setVertical] = useState('bottom');
  const [horizontal, setHorizontal] = useState('right');
  const [open, setOpen] = useState(false);
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('sdsdsdsds');
  const [selectedFile, setSelectedFile] = useState([]);

  const attachmentRef = useRef(null);

  const fetchAttachments = async (event) => {
    const attachments = await GetCandidateAttachmentsList(id);
    setAttachments(attachments);
    setLoading(false);
  };
  useEffect(() => {
    fetchAttachments();
  }, [selectedFile, location]);

  const handleClose = () => {
    setOpen(false);
  };
  const SaveAttachment = async (event) => {
    event.preventDefault();

    setLoading(true);
    var payload = selectedFile;
    //  console.log(payload);

    let response = await PostCandidateAttachment(id, payload);

    //  console.log('PostResponse:', response);
    if (response.status == 200) {
      fetchAttachments();
      setSelectedFile([]);
      props.setMessage(response.data);
      props.setSaved(true);
      props.setOpen(true);
      setLoading(false);
    } else {
      props.setMessage(response.data);
      props.setSaved(false);
      props.setOpen(true);
      setLoading(false);
      // setPosting(false);
    }
  };
  const uploadFile = (event) => {
    event.preventDefault();
    const uploaded = [...selectedFile];
    for (let i = 0; i < event.target.files.length; i++) {
      let reader = new FileReader();
      let file = event.target.files[i];
      // console.log('FileName', file); //I can see the file's info

      reader.onload = (event) => {
        //  console.log('event', event.target.result[i]);
        // console.log("asas", reader.result);
        const row = {
          attachment: reader.result,
          fileName: file.name,
        };
        uploaded.push(row);
        // setSelectedFile([row]);
        // console.log('row', row);
        // console.log("State", selectedFile);
      };
      reader.readAsDataURL(file);

      // console.log('asas', reader.result);
      reader.onerror = function (error) {
        //     console.log('Error: ', error);
      };
    }
    setSelectedFile(uploaded);
  };
  const deleteAttachmentRow = (fileName) => {
    // console.log(selectedFile);
    const newList = selectedFile.filter((item) => item.fileName !== fileName);
    //  console.log('new List', newList);

    // setGrandTotal(parseInt(grandTotal) - price * quantity);
    setSelectedFile(newList);
  };

  const deleteAttachment = async (attachment) => {
    event.preventDefault();
    setLoading(true);

    // console.log('IDD:', attachment);
    let response = await DeleteCandidateAttachment(attachment);
    // console.log('Console:', response);
    if (response.status == 200) {
      const newList = attachments.filter((item) => item.id !== attachment);
      setAttachments(newList);
      props.setMessage(response.data);
      props.setSaved(true);
      props.setOpen(true);
      setLoading(false);
    } else {
      props.setMessage(response.data);
      props.setSaved(false);
      props.setOpen(true);
      setLoading(false);
    }
  };
  const GetAttachment = async (path) => {
    // var file = await DownloadAttachment(path);
    var file = await DownloadTreeAttachment('1', false, '', path, false);
    // console.log('file', file);
    const url = window.URL.createObjectURL(new Blob([file.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', path); //or any other extension
    document.body.appendChild(link);
    link.click();
  };

  return (
    <>
      <Helmet>
        <title> Documents | Immigration System </title>
      </Helmet>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Add Documents
          </Typography>
          <Typography variant="h4" marginRight={12} gutterBottom></Typography>
          <Typography variant="h4" marginRight={12} gutterBottom></Typography>
          <Typography variant="h4" marginRight={12} gutterBottom></Typography>
          <Typography variant="h4" marginRight={12} gutterBottom></Typography>

          <TextField
            type="file"
            label=""
            inputProps={{ multiple: true }}
            inputRef={attachmentRef}
            onChange={uploadFile}
          />

          <Button onClick={SaveAttachment} variant="contained">
            Save
          </Button>
        </Stack>
        <Box
          p={3}
          component={Paper}
          boxShadow={3}
          marginBottom={4}
          sx={{ border: 0, borderColor: 'primary.main', borderRadius: '16px' }}
        >
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <br></br>
              <br></br>
              <TableContainer component={Paper}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>Sr#</TableCell>

                      <TableCell>Attachment Name</TableCell>

                      <TableCell>Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {selectedFile?.map((row, index) => (
                      <TableRow key={index + 1}>
                        <TableCell>{index + 1}</TableCell>

                        <TableCell>{row.fileName}</TableCell>
                        <TableCell>
                          <IconButton
                            onClick={() => deleteAttachmentRow(row.fileName)}
                            aria-label="delete"
                            size="small"
                          >
                            <Trash />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </Box>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Saved Documents
          </Typography>
        </Stack>
        {loading ? (
          <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
            <CircularProgress size={60} thickness={3} value={100} />
          </Grid>
        ) : (
          <Box
            p={4}
            component={Paper}
            boxShadow={3}
            sx={{ border: 0, borderColor: 'primary.main', borderRadius: '16px' }}
          >
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <br></br>
                <br></br>
                <TableContainer component={Paper}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Sr#</TableCell>
                        <TableCell>Document Name</TableCell>
                        <TableCell>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {attachments?.map((row, index) => (
                        <TableRow key={index + 1}>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>{row.docName}</TableCell>

                          <TableCell>
                            <IconButton onClick={() => GetAttachment(row.path)} aria-label="delete" size="small">
                              <Download />
                            </IconButton>
                            <IconButton aria-label="delete" size="small">
                              <ModalLayout
                                // title="Delete"
                                component={<Trash />}
                                description="Are You Sure you want to Delete?"
                                Hit={() => deleteAttachment(row.id)}
                              />
                              {/* <Trash borderColor='red' /> */}
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          </Box>
        )}
      </Container>
      {saved ? (
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          key={vertical + horizontal}
          open={open}
          autoHideDuration={4000}
          onClose={handleClose}
        >
          <Alert elevation={6} variant="filled" onClose={handleClose} severity="success">
            {message}
          </Alert>
        </Snackbar>
      ) : (
        <Snackbar
          key={vertical + horizontal}
          anchorOrigin={{ vertical, horizontal }}
          open={open}
          autoHideDuration={4000}
          onClose={handleClose}
        >
          <Alert elevation={6} variant="filled" onClose={handleClose} severity="error">
            {message}
          </Alert>
        </Snackbar>
      )}
    </>
  );
}
